import React from "react";

const VisibilityRange = ({ visibility = 0, weatherCondition = "clear" }) => {
  const getVisibilityColor = (visibility) => {
    if (visibility >= 10000) return "#4CAF50"; // Excellent
    if (visibility >= 5000) return "#2196F3"; // Good
    if (visibility >= 2000) return "#FFC107"; // Moderate
    if (visibility >= 1000) return "#FF9800"; // Poor
    return "#F44336"; // Very Poor
  };

  const getVisibilityDescription = (visibility) => {
    if (visibility >= 10000) return "Excellent";
    if (visibility >= 5000) return "Good";
    if (visibility >= 2000) return "Moderate";
    if (visibility >= 1000) return "Poor";
    return "Very Poor";
  };

  const getVisibilityIcon = (weatherCondition) => {
    if (!weatherCondition) return "👁️";

    const condition = weatherCondition.toLowerCase();
    if (condition.includes("fog") || condition.includes("mist")) return "🌫️";
    if (condition.includes("haze")) return "🌫️";
    if (condition.includes("smoke")) return "💨";
    if (condition.includes("dust")) return "💨";
    if (condition.includes("sand")) return "💨";
    return "👁️";
  };

  const visibilityColor = getVisibilityColor(visibility);
  const visibilityDescription = getVisibilityDescription(visibility);
  const visibilityIcon = getVisibilityIcon(weatherCondition);

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="text-4xl">{visibilityIcon}</div>
        <div className="text-right">
          <div
            className="text-2xl font-bold"
            style={{ color: visibilityColor }}
          >
            {(visibility / 1000).toFixed(1)} km
          </div>
          <div className="text-sm text-gray-600">
            {visibilityDescription} Visibility
          </div>
        </div>
      </div>

      <div className="relative h-4 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="absolute h-full rounded-full"
          style={{
            width: `${Math.min((visibility / 10000) * 100, 100)}%`,
            backgroundColor: visibilityColor,
          }}
        />
      </div>

      <div className="mt-4 text-sm text-gray-600">
        {visibility >= 10000 &&
          "Clear visibility - No restrictions for outdoor activities."}
        {visibility >= 5000 &&
          visibility < 10000 &&
          "Good visibility - Normal outdoor activities are safe."}
        {visibility >= 2000 &&
          visibility < 5000 &&
          "Moderate visibility - Exercise caution during outdoor activities."}
        {visibility >= 1000 &&
          visibility < 2000 &&
          "Poor visibility - Consider limiting outdoor activities."}
        {visibility < 1000 &&
          "Very poor visibility - Avoid outdoor activities if possible."}
      </div>

      {weatherCondition && (
        <div className="mt-2 text-sm text-gray-500">
          Current condition: {weatherCondition}
        </div>
      )}
    </div>
  );
};

export default VisibilityRange;
